import { useRef, useState } from "react";

import * as designMeta from "../../../api/design/meta";
import * as qualityMeta from "../../../api/quality/meta";
import * as approvalMeta from "../../../api/approval/meta";
import * as materialMeta from "../../../api/material/docs";
import * as safetyMeta from "../../../api/safety";
import * as constMeta from "../../../api/const"; // ★ const 통합 meta API

import { uploadDesignFile } from "../../../api/design/file";

import AttachmentBox from "../papers/AttachmentBox";
import ApprovalLine from "../../approval/ApprovalLine";
import TableCell from "../ui/TableCell";
import DocSummaryCard from "../form/DocSummary";

import FileList from "../papers/FileList";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { updateDocPersons } from "../../../api/papers";

/* ---------------------------------------------------
   1) 모듈별 create/update만 정의
--------------------------------------------------- */
const saveFunctions = {
  design: {
    create: designMeta.createMeta,
    update: designMeta.updateMeta,
  },
  quality: {
    create: qualityMeta.createQualityMeta,
    update: qualityMeta.updateQualityMeta,
  },
  approval: {
    create: approvalMeta.createMeta,
    // update: approvalMeta.updateApprovalMeta,
  },
  material: {
    // create: materialMeta.createMaterialMeta,
    // update: materialMeta.updateMaterialMeta,
  },
  safety: {
    create: safetyMeta.saveSafetyDoc,
    update: safetyMeta.saveSafetyDoc,
  },
  const: {
    create: constMeta.createConstMeta, // ★ DAILY / PROGRESS 모두 포함
    update: constMeta.updateConstMeta,
  },
};

/* ---------------------------------------------------
   공통 유틸
--------------------------------------------------- */
function ensureProject(p) {
  return (
    p ||
    localStorage.getItem("projectId") ||
    localStorage.getItem("projectCode")
  );
}

function goBoard({ module, project, redirectTo }) {
  const url =
    redirectTo ||
    (module === "design"
      ? `/project/${project}/design/list`
      : module === "quality"
        ? `/project/${project}/quality/qualityboard`
        : module === "safety"
          ? `/project/${project}/safety/board`
          : `/project/${project}`);

  window.location.replace(url);
}

export default function MobileFormContentManager({
  params,
  docName,
  docDescribe,
  getBody,
  children,
  onChangeId,
  onSaved,
  redirectTo,
  summaryConfig,
  summaryComponent,
  requestPeople,
  headerExtraButtons, // 💡 문서 입력 헤더 오른쪽에 붙일 추가 버튼
  hideBackButton = false, // 💡 모바일에서 "목록으로" 버튼 숨김
}) {
  const attachmentRef = useRef();
  const approvalRef = useRef();

  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [approvalMode, setApprovalMode] = useState("normal");

  const [loadedFiles, setLoadedFiles] = useState([]);

  const navigate = useNavigate();

  /* ---------------------------------------------------
     norm 구성
  --------------------------------------------------- */
  const norm = {
    module: (params?.module || "").toLowerCase(),
    project: ensureProject(params?.project),
    form_type: (params?.formType || params?.doc_type || "").toUpperCase(),
    dns: params?.dns ?? null,
  };

  //단일결재를 위해..
  const body = getBody?.() || {};
  const values = body.values || body;

  console.log(requestPeople, "@@");

  if (values.doc_type === "order" || values.doc_type === "ordercomplete") {
    approvalRef.current?.setLines?.([
      {
        id: Date.now(),
        approver_id: values.confirmer,
        approver_name: values.confirmer_name,
        order: 1,
        approval_type: "sequential",
        approval_category: "approval",
      },
    ]);
  }
  /* ---------------------------------------------------
     저장 핸들러
  --------------------------------------------------- */
  const handleSave = async () => {
    if (saving) return;

    setSaving(true);
    setError("");

    try {
      const body = getBody?.() || {};
      const values = body.values || body;
      const meta = values.meta || {};

      const fns = saveFunctions[norm.module];
      if (!fns) throw new Error(`지원되지 않는 모듈: ${norm.module}`);

      const project = norm.project;
      if (!project) throw new Error("프로젝트 정보가 없습니다.");

      let dns = norm.dns;
      let result;

      /* ⭐ design만 파일 업로드 처리를 위해 예외 */
      if (norm.module === "design") {
        result = dns ? await fns.update(dns, values) : await fns.create(values);

        dns = dns || result?.dns || result?.doc_dns;
        if (!dns) throw new Error("DNS 생성 실패(design)");

        // DCN 파일 업로드
        if (norm.form_type === "DCN" && Array.isArray(meta.details)) {
          for (let i = 0; i < meta.details.length; i++) {
            const d = meta.details[i];
            if (d.file && !d.fileUrl) {
              const uploaded = await uploadDesignFile(d.file, dns, {
                index: i + 1,
              });
              d.fileUrl = uploaded.url;
              d.fileName = uploaded.file_name;
              d.fileId = uploaded.id;
              d.file = null;
            }
          }
        }
      } else {
        /* ⭐ const 모듈 - DAILY만 workreport API로 별도 처리 */
        if (norm.module === "const" && norm.form_type === "DAILY") {
          console.log("⛑ DAILY → WorkReport API로 저장");

          // DAILY는 meta만 보냄
          result = dns
            ? await constMeta.updateWorkReport(dns, values.meta)
            : await constMeta.createWorkReport(values.meta);

          dns = dns || result?.dns;
          if (!dns) throw new Error("DNS 생성 실패 (DAILY)");
        } else {
          /* ⭐ const의 나머지 문서(PROGRESS/ORDER 등)는 meta 저장 */
          result = dns
            ? await fns.update(dns, values)
            : await fns.create(values);

          dns = dns || result?.dns || result?.doc_dns;
          if (!dns) throw new Error("DNS 생성 실패(meta)");

          if (
            values.doc_type === "order" ||
            values.doc_type === "ordercomplete"
          ) {
            console.log("ORDER/ORDERCOMPLETE → 자동 결재 생성");

            if (values.confirmer) {
              // ⏳ setState 비동기 → 다음 tick에서 save 실행
              await new Promise((resolve) => setTimeout(resolve, 0));

              await approvalRef.current?.save?.(dns);
            }
          }
        }
      }

      /* ---------------------------------------------------
         공통 후처리
      --------------------------------------------------- */
      // 각 에디터에서 attachmentRef를 onChange를 통해 전달하므로,
      // body.values.attachmentRef 또는 body.attachmentRef를 사용
      const editorAttachmentRef = body?.attachmentRef || body?.values?.attachmentRef;
      if (editorAttachmentRef?.current?.save) {
        await editorAttachmentRef.current.save(dns);
      }

      if (approvalMode === "approval") {
        await approvalRef.current?.save?.(dns);
      }
      if (requestPeople?.length > 0) {
        console.log("문서 담당자 업데이트:", requestPeople);
        updateDocPersons(
          dns,
          requestPeople.map((p) => p.id)
        );
      }

      onChangeId?.(dns);
      onSaved?.({ dns });

      goBoard({ module: norm.module, project, redirectTo });

      alert("문서 저장 완료");
    } catch (e) {
      console.error(e);
      setError(e?.message || "저장 중 오류 발생");
    } finally {
      setSaving(false);
    }
  };

  /* ---------------------------------------------------
     렌더링 - 모바일 최적화 (부모 컨테이너 규칙 따름)
  --------------------------------------------------- */
  return (
    <div className="w-full space-y-2">
      {!hideBackButton && (
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-1 text-gray-500 hover:text-gray-700 mb-2"
        >
          <ArrowLeft size={16} /> 목록으로
        </button>
      )}

      {/* 제목 영역 */}
      <div className="bg-white rounded-lg p-3 border shadow-sm">
        <h1 className="text-base font-bold text-gray-900 truncate">{docName}</h1>
        <p className="text-[11px] text-gray-500 mt-0.5 break-words">{docDescribe}</p>
      </div>

      {/* 문서 입력 영역 */}
      <div className="bg-white rounded-lg border overflow-hidden shadow-sm">
        <div className="bg-gray-50 px-3 py-2 border-b flex items-center justify-between">
          <h2 className="text-xs font-semibold text-gray-900 truncate flex-1">문서 입력</h2>
          <div className="flex items-center gap-1.5 flex-shrink-0">
            {headerExtraButtons}
            <button
              onClick={handleSave}
              disabled={saving}
              className="px-2.5 py-1.5 rounded bg-blue-600 text-white text-xs font-medium hover:bg-blue-700 disabled:bg-gray-300 disabled:text-gray-500 transition-colors whitespace-nowrap"
            >
              {saving ? "저장 중…" : "저장"}
            </button>
          </div>
        </div>

        {/* 결재 버튼 (design/safety만) */}
        {["design", "safety", "approval"].includes(norm.module) && (
          <div className="px-3 py-2 border-b flex items-center gap-2 flex-wrap bg-white">
            <span className="text-[11px] text-gray-600 font-medium">문서 유형</span>
            <button
              onClick={() => setApprovalMode("normal")}
              className={`px-2 py-0.5 rounded border text-[11px] whitespace-nowrap transition-colors ${approvalMode === "normal"
                  ? "bg-gray-800 text-white border-gray-800"
                  : "bg-white text-gray-600 border-gray-200 hover:bg-gray-50"
                }`}
            >
              일반
            </button>
            <button
              onClick={() => setApprovalMode("approval")}
              className={`px-2 py-0.5 rounded border text-[11px] whitespace-nowrap transition-colors ${approvalMode === "approval"
                  ? "bg-indigo-600 text-white border-indigo-600"
                  : "bg-white text-gray-600 border-gray-200 hover:bg-gray-50"
                }`}
            >
              결재
            </button>
          </div>
        )}

        {/* Children 영역 */}
        <div className="p-3">
          {children}
        </div>

        {/* 숨겨진 ApprovalLine (order 자동결재용) */}
        {["order", "ordercomplete"].includes(
          norm.form_type.toLowerCase()
        ) && (
            <div style={{ display: "none" }}>
              <ApprovalLine ref={approvalRef} />
            </div>
          )}

        {/* 결재 설정 */}
        {approvalMode === "approval" &&
          ["design", "safety", "approval"].includes(norm.module) && (
            <div className="border-t p-3 bg-gray-50">
              <div className="mb-2 text-[11px] font-medium text-gray-700">결재 설정</div>
              <ApprovalLine ref={approvalRef} />
            </div>
          )}
      </div>

      {/* 요약 카드 */}
      {(summaryComponent || summaryConfig) && (
        <div className="bg-white rounded-lg border overflow-hidden shadow-sm">
          {summaryComponent ? (
            summaryComponent
          ) : summaryConfig ? (
            <DocSummaryCard {...summaryConfig} />
          ) : null}
        </div>
      )}

      {/* 에러 메시지 */}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-red-600 text-xs shadow-sm">
          {error}
        </div>
      )}
    </div>
  );
}

